import { darkPalette, lightPalette } from './palette'

const activeFocusShadow = (color: string) => `0 0 0 3px ${color}`

export const lightShadows = {
  xs: '0 1px 2px rgba(0, 0, 0, 0.05), 0 1px 3px rgba(0, 0, 0, 0.1)',
  sm: '0 2px 4px rgba(0, 0, 0, 0.06), 0 4px 6px rgba(0, 0, 0, 0.1)',
  md: '0 4px 6px rgba(0, 0, 0, 0.07), 0 10px 13px rgba(0, 0, 0, 0.1), 0 15px 20px rgba(0, 0, 0, 0.08)',
  lg: '0 8px 12px rgba(0, 0, 0, 0.08), 0 17px 29px rgba(0, 0, 0, 0.1), 0 29px 44px rgba(0, 0, 0, 0.07)',
  xl: '0 12px 16px rgba(0, 0, 0, 0.08), 0 24px 48px rgba(0, 0, 0, 0.12), 0 48px 80px rgba(0, 0, 0, 0.08)',
  buttonInner: `0 2px 4px 0 ${lightPalette.effects['button-inner']} inset`,
  buttonDrop: `0 2px 8px 0 ${lightPalette.effects['button-drop']}`,
  activeFocus: activeFocusShadow(lightPalette.effects['active-focus']),
  activeAi: activeFocusShadow(lightPalette.effects['active-ai']),
  activeError: activeFocusShadow(lightPalette.effects['active-error']),
  activeSuccess: activeFocusShadow(lightPalette.effects['active-success']),
  activeBrand: activeFocusShadow(lightPalette.effects['active-brand']),
} as const

export const darkShadows = {
  xs: '0 1px 2px rgba(0, 0, 0, 0.3), 0 1px 3px rgba(0, 0, 0, 0.2)',
  sm: '0 2px 4px rgba(0, 0, 0, 0.4), 0 4px 6px rgba(0, 0, 0, 0.3)',
  md: '0 4px 6px rgba(0, 0, 0, 0.5), 0 10px 13px rgba(0, 0, 0, 0.4), 0 15px 20px rgba(0, 0, 0, 0.3)',
  lg: '0 8px 12px rgba(0, 0, 0, 0.6), 0 17px 29px rgba(0, 0, 0, 0.5), 0 29px 44px rgba(0, 0, 0, 0.4)',
  xl: '0 12px 16px rgba(0, 0, 0, 0.7), 0 24px 48px rgba(0, 0, 0, 0.6), 0 48px 80px rgba(0, 0, 0, 0.5)',
  buttonInner: `0 2px 4px 0 ${darkPalette.effects['button-inner']} inset`,
  buttonDrop: `0 2px 8px 0 ${darkPalette.effects['button-drop']}`,
  activeFocus: activeFocusShadow(darkPalette.effects['active-focus']),
  activeAi: activeFocusShadow(darkPalette.effects['active-ai']),
  activeError: activeFocusShadow(darkPalette.effects['active-error']),
  activeSuccess: activeFocusShadow(darkPalette.effects['active-success']),
  activeBrand: activeFocusShadow(darkPalette.effects['active-brand']),
} as const
